import { Replica } from '@kit/sync/replica/replica';
import { tokenStorage } from './token-storage';

/** The device's replica of the server: every read and write of records goes through it. */
export const replica = new Replica({ name: 'survival-kit', baseUrl: '/api', getToken: tokenStorage.get });
